<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-row :gutter="20">
          <el-col :span="3">
            <el-upload class="upload-demo"
                       style="width:100px"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,223)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button icon="sj-icon-add"
                         type="primary"
                         size="mini">新增覆盖预估
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)"></sj-progress>
            成功:{{scope.row.success_count}} 错误:{{scope.row.error_count}}
          </template>
        </el-table-column>
        <el-table-column prop="cover_type"
                         label="类型"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.cover_type"
                  v-if="scope.row.task_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="scope.row.status === item.value">{{item.label}}</span>
            <span v-if="scope.row.status === -2 && scope.row.error_message">{{scope.row.error_message}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <span v-if="(scope.row.status === 3 && scope.row.error_count > 0) || scope.row.status === -2">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
            <span v-if="scope.row.status === 3">
              <el-button type="text"
                         size="mini"
                         @click="onDownExportFile(scope.row.id)">下载处理结果</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>

import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'

export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      options: {
        cover_type: [
          {value: 223, label: '覆盖预估'},
        ],
      },
      search: {
        collection_type: 3, /** 卖场管理 */
        task_type: [223], /** 覆盖预估 */
      },
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
  }),
  created () {
  },
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryBatchUpload', params)
    },
    onDownSourceFile (id) {
      downloadJS(request.items.downSourceFile(id))
    },
    onDownErrorFile (id) {
      downloadJS(request.items.downErrorFile(id))
    },
    onDownExportFile (id) {
      downloadJS(request.items.downExportFile(id))
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('createCoverBatch', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/cover-estimate/pages/CoverUploadTable.vue